export class Subcategory {

    public id: string = "0";
    public name: string;
    public partner: boolean;
    public hidden: boolean;

    public sponsor: boolean; // categoria associda a patrocinador
    public front_desk: boolean; // exibir no balção
    public annuity: boolean; // cobrar anuidade ou ãoxibir no balção
    
    public documents: string;
    public documents_en: string;

    public docList: any[]
    
    constructor() {}
}